import { ITEM_STATUSES } from '../../../constants/items';
import template from './timeline.html';
import './timeline.global.css';

const OPEN_STATUSES = [ITEM_STATUSES.NOT_STARTED, ITEM_STATUSES.STARTED];

class TimelineController {
  isOpen(step) {
    return OPEN_STATUSES.indexOf(step.status) !== -1;
  }
}

export const TimelineComponent = {
  controller: TimelineController,
  bindings: {
    steps: '<',
    change: '&',
  },
  template,
};
